import React, { useCallback, useMemo } from "react";
import useTimeSeries from "hooks/useTImeSeries";
import { connectWidget } from "../../widget-connector/WidgetConnector";
import useWidgetProxy from "hooks/useWidgetProxy";
import { TIMESERIES_OPTIONS_TEMPLATE } from "hooks/useTimeSeriesWithTimeRangeExplorer";

const BaseTimeSeriesWidget = (props) => {
  const { widget, updateWidget, stacks } = props;
  const {
    proxy: optionsProxy,
    updateProxy: updateOptionsProxy,
    commit,
    rollback,
    isDirty,
  } = useWidgetProxy(widget, TIMESERIES_OPTIONS_TEMPLATE);

  const timeframe = useMemo(
    () => optionsProxy?.options?.timeframe ?? props.defaultTimeframe ?? {},
    [props.defaultTimeframe, optionsProxy?.options?.timeframe]
  );
  
  const setTimeframe = useCallback(
    (tf) => {
      if (!tf.start) {
        return;
      }
      tf.start = tf.start.valueOf();
      updateOptionsProxy(
        {
          options: {
            ...optionsProxy.options,
            timeframe: { ...timeframe, ...tf },
          },
        }
      );
    },
    [optionsProxy.options, timeframe, updateOptionsProxy]
  );

  const { startTime, endTime, streams, maxWindowInSeconds, loading } =
    useTimeSeries({
      widget,
      timeframe,
      stacks,
      fixedWindow: props.fixedWindow,
    });

  return (
    <>
      {props.children({
        widget,
        updateWidget,
        optionsProxy,
        updateOptionsProxy,
        stacks,
        startTime,
        endTime,
        streams,
        setTimeframe,
        timeframe,
        maxWindowInSeconds,
        loading,
        removeWidget: props.removeWidget,
        readOnly: props.readOnly,
        commit,
        rollback,
        isDirty,
      })}
    </>
  );
};

export default connectWidget(BaseTimeSeriesWidget);
